<template>
    <div class="map flex1 zjmap" id="zjmap">

    </div>
</template>

<script>
  export default {
    name: "zj-map",
    data() {
      return {
        map: null
      }
    },
    mounted() {
      this.map = new AMap.Map('zjmap', {
        mapStyle: 'amap://styles/midnight',
        zoom: 7,
        center: [120.658775,29.307209]
      });
      this.makeLayer();
    },
    methods: {
      makeLayer() {
        const layer = new Loca.LinkLayer({
          map: this.map,
          fitView: true,
        });
        layer.setData([
          {name:'1',line:["120.672111,28.000575","120.209947,30.245853"]},
          {name:'2',line:["118.87263,28.941708","120.209947,30.245853"]},
          {name:'3',line:["120.750865,30.762653","120.209947,30.245853"]},
        ], {
          lnglat: 'line'
        });
        layer.setOptions({
          style: {
            // 曲率 [-1, 1] 区间
            curveness: 0.2,
            opacity: 0.8,
            color: '#5695F6'
          }
        });
        layer.render();
      }
    },
  }
</script>

<style scoped>

</style>
